import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useReferralAndDiscountsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemReferralCode */
  const menuItemReferralCode = {
    id: "referralCode",
    title: t("Modules.Configuration.referralCode"),
    url: baseRouteMakerForSuperAdmin(routes.REFERRAL_CODE),
  };
  tempMenuGroup.push(menuItemReferralCode);
  /* menuItemReferralCode */

  /* menuItemDiscountCodes */
  const menuItemDiscountCodes = {
    id: "giftCode",
    title: t("SignUp.giftCodes"),
    url: baseRouteMakerForSuperAdmin(routes.DISCOUNT_CODES),
  };
  tempMenuGroup.push(menuItemDiscountCodes);
  /* menuItemDiscountCodes */

  /* menuItemCouponCodes */
  const menuItemCouponCodes = {
    id: "couponCodes",
    title: t("SignUp.couponCodes"),
    url: baseRouteMakerForSuperAdmin(routes.COUPON_CODES),
  };
  tempMenuGroup.push(menuItemCouponCodes);
  /* menuItemCouponCodes */

  return tempMenuGroup;
};
